<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<!--<div class="header-form">-->
<!--  <ng-template ngFor let-fieldConfig [ngForOf]="formConfig[0].fields" let-fieldIndex="index">-->
<!--    <div class="column">-->
<!--      <label *ngIf="fieldConfig.field && fieldConfig.type!=FieldTypes.CHECKBOX" [for]="fieldConfig.field"-->
<!--             [className]="fieldConfig.required===true?'field-required':''"-->
<!--             [style]="'margin: 4px 3px 0 20px !important;'">-->
<!--        {{ fieldConfig.label ? fieldConfig.label : 'page.' + this.transPartKey + '.form.' + fieldConfig.field | translate }}-->
<!--      </label>-->
<!--      <app-cc-field-dispatcher #ccSubForm [loading]="false"-->
<!--                               [transPartKey]="transPartKey"-->
<!--                               [(formRecord)]="tableCurrentRequest" [fieldConfig]="fieldConfig"-->
<!--                               (formRecordChange)="reLoadRecords()"-->
<!--                               [style]="fieldConfig.type===FieldTypes.MULTISELECT?'margin: 2px 0 0 0 !important;'-->
<!--                                   :fieldConfig.type===FieldTypes.CHECKBOX?'margin: 3px 0 0 30px !important;':'margin: 1px 0 0 0 !important;'">-->
<!--      </app-cc-field-dispatcher>-->
<!--    </div>-->
<!--  </ng-template>-->
<!--  <div class="column-flex">-->
<!--  </div>-->
<!--</div>-->
<app-cc-table body #ccTable [transPartKey]="transPartKey"
              [tableConfig]="tableConfig" [headerButtonConfig]="headerButtonConfig"
              [contextMenuConfig]="contextMenuConfig" [(selectedRecord)]="formRecord"
              [(selectedRecords)]="selectedRecords"
              [records]="records" [totalRecords]="totalRecords" [loading]="tableLoading"
              [currentRequest]="tableCurrentRequest"
              (onRowDblClick)="onRowDblClick($event)" (loadRecordsEvent)="needLoadRecords($event)"
              [fieldName]="'id'" [fieldId]="'id'" selectionMode="single" (onContextMenuShow)="refreshContextMenu()"
              [defaultSortField]="'moneyOwner'" [defaultSortOrder]="1"
>
  <span toolbar-left class="ml-20-imp">
      <i class="toolbar-separator fa fa-diamond"></i>
  </span>
  <span toolbar-left class="d-flex" *ngIf="formConfig">
    <app-cc-form #ccFormTable [formConfig]="formConfig" [(formRecord)]="tableCurrentRequest" [transPartKey]="transPartKey" (formRecordChange)="reLoadRecords()"></app-cc-form>
<!--      <ng-template ngFor let-fieldConfig [ngForOf]="formConfig[0].fields" let-fieldIndex="index">-->
<!--          <label *ngIf="fieldConfig.field && fieldConfig.type!=FieldTypes.CHECKBOX" [for]="fieldConfig.field"-->
<!--                         [className]="fieldConfig.required===true?'field-required':''"-->
<!--                 [style]="'margin: 4px 3px 0 20px !important;'">-->
<!--                    {{fieldConfig.label ? fieldConfig.label : 'page.' + this.transPartKey + '.form.' + fieldConfig.field | translate}}-->
<!--                  </label>-->
<!--          <app-cc-field-dispatcher #ccSubForm [loading]="false"-->
<!--                                   [transPartKey]="transPartKey"-->
<!--                                   [(formRecord)]="tableCurrentRequest" [fieldConfig]="fieldConfig"-->
<!--                                   (formRecordChange)="reLoadRecords()"-->
<!--                                   [style]="fieldConfig.type===FieldTypes.MULTISELECT?'margin: 2px 0 0 0 !important;'-->
<!--                                   :fieldConfig.type===FieldTypes.CHECKBOX?'margin: 3px 0 0 30px !important;':'margin: 1px 0 0 0 !important;'">-->
<!--          </app-cc-field-dispatcher>-->
<!--        </div>-->
<!--      </ng-template>-->
<!--            <app-cc-field-dispatcher #ccSubForm [loading]="false"-->
<!--                                     [transPartKey]="transPartKey"-->
<!--                                     [(formRecord)]="formRecord" [fieldConfig]="fieldConfig"></app-cc-field-dispatcher>-->
<!--          <app-cc-form #ccForm [transPartKey]="transPartKey"-->
<!--                       [loading]="formLoading"-->
<!--                       [formConfig]="formConfig"-->
<!--                       [(formRecord)]="tableCurrentRequest" (formRecordChange)="formRecordChanged($event)"-->
<!--                       [loadingProgressValue]="settingsFormLoadingProgressValue"-->
<!--          ></app-cc-form>-->
  </span>
</app-cc-table>

<app-invoice-detail-dialog #invoiceDetailDialog (invoiceChange)="invoiceChanged()"></app-invoice-detail-dialog>
<app-invoice-update-outstanding-form #updateOutstandingDialog
    (onSavedForm)="reLoadRecords()"></app-invoice-update-outstanding-form>
